const AboutIllustration1 = (props) => (
  <svg
    width={473}
    height={770}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M323.852 0c-38.721 0-77.062 8.373-112.835 24.64-35.773 16.266-68.277 40.108-95.657 70.165-27.38 30.057-49.098 65.74-63.916 105.011C36.627 239.087 29 281.178 29 323.685h294.852V0Z"
      fill="#F1C8DB"
    />
    <path
      d="M324.666 162c-19.392 0-38.594 4.193-56.51 12.34-17.915 8.146-34.194 20.087-47.906 35.14-13.712 15.053-24.589 32.923-32.01 52.59-7.421 19.668-11.24 40.747-11.24 62.035h147.666V162Z"
      fill="#000"
    />
    <path fill="#D6FEAE" d="M177.132 324v321.714H-118V324z" />
    <path
      d="M-118 647.685c38.72 0 77.062-8.373 112.835-24.639 35.773-16.267 68.278-40.109 95.657-70.166 27.38-30.057 49.098-65.74 63.916-105.011 14.818-39.271 22.444-81.362 22.444-123.869H-118v323.685Z"
      fill="#000"
    />
    <path
      d="M-118.334 485.211c19.392 0 38.593-4.193 56.51-12.34 17.915-8.146 34.193-20.087 47.905-35.14 13.712-15.053 24.59-32.923 32.01-52.59 7.421-19.668 11.24-40.748 11.24-62.036h-147.665v162.106Z"
      fill="#F1C8DB"
    />
    <path fill="#D6FEAE" d="M0 645h177v125H0z" />
  </svg>
);

export default AboutIllustration1;
